var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAccessible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 64,
    viewBox: "0 0 60 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 32.9407C55 40.1594 50.1815 46.1919 43.75 47.6589M21.6667 27.3133C20.5132 26.4994 19.2015 25.9154 17.7904 25.6233C17.1187 25.4843 16.4246 25.4114 15.7143 25.4114C9.79695 25.4114 5 30.4679 5 36.7055C5 42.9431 9.79695 47.9997 15.7143 47.9997M17.7904 25.6233C17.2176 23.9938 16.9047 22.2313 16.9047 20.3918C16.9047 12.0751 23.3007 5.33301 31.1905 5.33301C38.5397 5.33301 44.5927 11.1829 45.3877 18.7063M35.9525 18.7389C37.4417 18.184 39.0445 17.882 40.7142 17.882C42.351 17.882 43.9232 18.1722 45.3877 18.7063M45.3877 18.7063C47.0952 19.3291 48.6557 20.2836 50 21.4968",
    stroke: "#0057D9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 45.333C21.25 41.5618 21.25 39.6762 22.3483 38.5045C23.4467 37.333 25.2145 37.333 28.75 37.333H31.25C34.7855 37.333 36.5533 37.333 37.6518 38.5045C38.75 39.6762 38.75 41.5618 38.75 45.333V50.6663C38.75 54.4375 38.75 56.3231 37.6518 57.4949C36.5533 58.6663 34.7855 58.6663 31.25 58.6663H28.75C25.2145 58.6663 23.4467 58.6663 22.3483 57.4949C21.25 56.3231 21.25 54.4375 21.25 50.6663V45.333Z",
    stroke: "#0057D9",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 48H32.5",
    stroke: "#0057D9",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccessible);
export default __webpack_public_path__ + "static/media/icon-accessible.9b8042c6fa7730eeca2c2b91536de426.svg";
export { ForwardRef as ReactComponent };